class PasswordModal extends DetailsModal{constructor(){super(),this.querySelector('input[aria-invalid="true"]')&&this.open({target:this.querySelector("details")})}}customElements.define("password-modal",PasswordModal);
//# sourceMappingURL=/s/files/1/0710/0206/3115/t/4/assets/password-modal.js.map?v=1702318180
